const locale = {
  SIGN_IN_TITLE: 'Sign In',
  SIGN_IN_SUBTITLE: 'Sign in to your account',
  EMAIL_LABEL: 'Email Address',
  PASSWORD_LABEL: 'Password',
  SIGN_IN_BUTTON: 'Sign In',
  FORGOT_PASSWORD: 'Forgot password?',
  NO_ACCOUNT: "Don't have an account?",
  SIGN_UP_LINK: 'Sign up here',
  SIGNING_IN: 'Signing in...',
  
  // Validation messages
  EMAIL_REQUIRED: 'Email address is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  PASSWORD_REQUIRED: 'Password is required',
  // deepcode ignore NoHardcodedPasswords: just a label
  PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters',
  
  // Error messages
  INVALID_CREDENTIALS: 'Invalid email or password',
  ACCOUNT_NOT_FOUND: 'Account not found',
  TOO_MANY_ATTEMPTS: 'Too many attempts. Please try again later',
  NETWORK_ERROR: 'Network error. Please check your connection',
  UNKNOWN_ERROR: 'An error occurred. Please try again',
  ACCOUNT_LOCKED: 'Account is locked. Contact administrator',
  EMAIL_NOT_VERIFIED: 'Email not verified. Check your email',
  
  // PropelAuth specific error messages
  RATE_LIMITED: 'Too many requests. Please wait before trying again',
  PASSWORD_POLICY_VIOLATION: 'Password does not meet security requirements',
  ACCOUNT_DISABLED: 'Your account has been disabled. Contact support',
  ACCOUNT_PENDING: 'Your account is pending approval',
  INVALID_EMAIL_FORMAT: 'Please enter a valid email address',
  PASSWORD_EXPIRED: 'Your password has expired. Please reset it',
  SESSION_EXPIRED: 'Your session has expired. Please sign in again',
  FORBIDDEN_ACTION: 'You are not authorized to perform this action',
  SERVICE_UNAVAILABLE: 'Authentication service is temporarily unavailable',
  MAINTENANCE_MODE: 'System is under maintenance. Please try again later',
  
  // Two-Factor Authentication messages
  TWO_FACTOR_REQUIRED: 'Two-factor authentication is required',
  TWO_FACTOR_CODE_INVALID: 'Invalid two-factor authentication code',
  TWO_FACTOR_CODE_EXPIRED: 'Two-factor authentication code has expired',
  TWO_FACTOR_SETUP_REQUIRED: 'Please set up two-factor authentication',
  
  // Account status messages
  ACCOUNT_INCOMPLETE: 'Please complete your account setup',
  EMAIL_VERIFICATION_REQUIRED: 'Please verify your email address to continue',
  EMAIL_VERIFICATION_SENT: 'Verification email sent. Check your inbox',
  PROFILE_INCOMPLETE: 'Please complete your profile information',
  
  // Network and API errors
  CONNECTION_TIMEOUT: 'Connection timeout. Please check your internet connection',
  SERVER_ERROR: 'Server error. Please try again later',
  BAD_REQUEST: 'Invalid request. Please check your input',
  UNAUTHORIZED: 'Authentication failed. Please try again',
  
  // Password policy messages
  PASSWORD_TOO_WEAK: 'Password is too weak. Use a stronger password',
  PASSWORD_REUSED: 'Cannot reuse a previous password',
  PASSWORD_COMMON: 'This password is too common. Choose a more unique password',
  
  // Additional PropelAuth error messages
  DOMAIN_NOT_ALLOWED: 'Email domain is not allowed',
  INVALID_FORM_DATA: 'Invalid form data. Please check your input',
  PASSWORD_LOGIN_DISABLED: 'Password login is currently disabled. Please use alternative login methods',
  ORG_CREATION_REQUIRED: 'Organization creation required. Redirecting to organization setup...',
};

export default locale;